import axios from "axios";
import { PATH } from "../../utils";
import {
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FAILURE,
  FETCH_ME_FAILURE,
  FETCH_ME_SUCCESS,
} from "./types";

const SESSION_EXPIRED = "SESSION_EXPIRED";
const BASE_URL = `${PATH}`;

const authHeader = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const handle401 = (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  if (dispatch) dispatch({ type: SESSION_EXPIRED });
};

export const actionUserMeGet = (onDone = () => {}) => {
  return async (dispatch) => {
    try {
      const res = await axios.get(`${BASE_URL}/users/me`, {
        headers: { ...authHeader() },
      });
      dispatch({ type: FETCH_ME_SUCCESS, payload: res.data || null });
      onDone(res.data);
    } catch (err) {
      if (err?.response?.status === 401) handle401(dispatch);
      dispatch({
        type: FETCH_ME_FAILURE,
        payload: err?.response?.data || { detail: "Error al obtener usuario" },
      });
      onDone(null);
    }
  };
};

/**
 * actionLogin
 * Backend Visum: POST /auth/login { correo, password } -> { access_token, role }
 * (instalacion de un solo negocio: el JWT trae {id, role, type:"access", exp},
 * sin id_cliente / tenant).
 */
export const actionLogin = (params, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      if (!params?.correo || !params?.password) {
        throw new Error("Correo y contrasena son requeridos");
      }

      const { data } = await axios.post(
        `${BASE_URL}/auth/login`,
        { correo: params.correo, password: params.password },
        { headers: { "Content-Type": "application/json" }, withCredentials: true }
      );

      const token = data?.access_token;
      if (!token) throw new Error("Respuesta de login invalida");

      localStorage.setItem("token", token);
      localStorage.setItem("email", params.correo);
      localStorage.setItem("last_login", new Date().toISOString());
      localStorage.setItem("role", data.role || "");

      try {
        const u = String(params.correo || "").trim().toLowerCase();
        if (u) {
          const saved = JSON.parse(localStorage.getItem("email_history") || "[]");
          const list = Array.isArray(saved) ? saved : [];
          const next = [u, ...list.filter((x) => String(x || "").toLowerCase() !== u)].slice(0, 15);
          localStorage.setItem("email_history", JSON.stringify(next));
        }
      } catch {}

      dispatch(fetchLoginSuccess({ role: data.role }));
      window.dispatchEvent(new Event("permisos-refresh"));
      onSuccess({ role: data.role });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Correo o contrasena incorrectos";
      dispatch(fetchLoginFailure(msg));
      onError(msg);
    }
  };
};

export const actionLogout = () => {
  return async () => {
    try {
      await axios.post(
        `${BASE_URL}/auth/logout`,
        {},
        { headers: { "Content-Type": "application/json" } }
      );
    } catch (err) {
      console.log(err);
    }
  };
};

export const actionForgotPassword = (email, callback, callbackError) => {
  return async () => {
    try {
      const { data } = await axios.post(`${BASE_URL}/auth/forgot-password`, { email });
      callback(data);
    } catch (error) {
      callbackError(error?.response?.data?.detail || error.message);
    }
  };
};

export const actionValidateResetCode = (email, code, callback, callbackError) => {
  return async () => {
    try {
      const { data } = await axios.post(`${BASE_URL}/auth/validate-reset-code`, { email, code });
      callback(data);
    } catch (error) {
      callbackError(error?.response?.data?.detail || error.message);
    }
  };
};

export const actionResetPassword = (payload, callback, callbackError) => {
  return async () => {
    try {
      const { data } = await axios.post(`${BASE_URL}/auth/reset-password`, payload);
      callback(data);
    } catch (error) {
      callbackError(error?.response?.data?.detail || error.message);
    }
  };
};

export const fetchLoginSuccess = (value) => ({
  type: FETCH_LOGIN_SUCCESS,
  payload: value,
});
export const fetchLoginFailure = (value) => ({
  type: FETCH_LOGIN_FAILURE,
  payload: value,
});
